import React from "react";
import "./styles.css";
import "./mobile.css";
import { SVGAsset } from "res";
import CustomAccordion, { CustomAccordionToggle, useCustomAccordion } from "components/custom-ui/CustomAccordion";

/**
 * @function MobileTableAccordionView
 * @param {STRING} className - Allows us to pass a unique class name to each MobileTabelAccordionView.
 * @param {React.Component} children - Allows us to inject other components/content.
 * @returns {React.Component}
 * @example
 * <MobileTableAccordionView>
 *  <MobileTableAccordionToggle>
 *    <span>Content</span>
 *  </MobileTableAccordionToggle>
 *  <CustomAccordionContent>
 *    <div>Content</div>
 *   </CustomAccordionContent>
 * </MobileTableAccordionView>
 */
export default function MobileTableAccordionView(props) {
  const className = props.className ?? "";
  return (
    <CustomAccordion className={`mobile-table-accordion-view ${className}`} activeClass="mobile-table-accordion-open" isOpen={ props.active }>
      {props.children}
    </CustomAccordion>
  );
}

/**
 * @function MobileTableAccordionToggle
 * @param {STRING} icon - Allows us to set the ID of the SVGAsset for the CustomAccordionToggle.
 * @param {React.Component} children - Allows us to inject other components/content.
 * @param {STRING} rightValue - Allows us to set the value that is right aligned, usually the amount value.
 * @returns {React.Component}
 * @example
 * <MobileTableAccordionToggle icon="RightChevronIcon" rightValue="$100.00">
 *   <span>Content</span>
 * </MobileTableAccordionToggle>
 */
export function MobileTableAccordionToggle(props) {
  const {state} = useCustomAccordion();
  const icon =  state ? "DownChevronIcon" : "RightChevronIcon"  ;
  const rightValue = props.rightValue ?? "[value]";
  const depositID = props.depositID ?? undefined;

  return (
    <CustomAccordionToggle onClick={ props.onClick }>
      <div className="mobile-table-view flex-container flex-horizontal">
        <div className="set-width icon-container">
          <SVGAsset id={icon} data-point={ `Mobile_Deposit_Chevron_${ depositID }`} />
        </div>
        <div className="flex-width">
          {props.children}
        </div>
        <div className="set-width flex-container flex-horizontal align-center text-right">
          <b>{rightValue}</b>
        </div>
      </div>
      </CustomAccordionToggle>
  );
}

/**
 * @function MobileTableAccordionDataItem
 * @param {STRING} className - Allows us to set a specific class name for each MobileTableAccordionDataItem.
 * @param {STRING} columnHeader - Sets the sub-text header for each line, this will correlate with the column header on the desktop version of the table.
 * @param {STRING} data - This sets the data for the line, this will correlate with the table cell on the desktop version of the table.
 * @example
 * <MobileTableAccordionDataItem className="account-info" columnHeader="To:" data="[accountName]" />
 */
export function MobileTableAccordionDataItem(props) {
  const className = props.className ?? "";
  const columnHeader = props.columnHeader ?? "[columnHeader]";
  const data = props.data ?? "[data]";

  return(
    <div className={`mobile-table-accordion-data-item ${className}`}>
      <span className="column-header-text sub-text">{columnHeader} </span>
      <span className="data-text">{data}</span>
    </div>
  );
}